// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentPatientSearchRecordModel } from './extEnrollmentPatientSearchRecordModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentPatientSearchResultModel {
    'results': Array<ExtEnrollmentPatientSearchRecordModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentPatientSearchResultModel>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<ExtEnrollmentPatientSearchRecordModel>"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentPatientSearchResultModel.attributeTypeMap;
    }
}
